import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52622dfb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "asHeaderMobile",
  "data-cy": "asHeaderChat"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "asHeaderMobile_back" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "asHeaderMobile_col -name" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "asHeaderMobile_title" }
const _hoisted_7 = { class: "asHeaderMobile_col -nav" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_menu = _resolveComponent("as-menu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'menuContainer': _ctx.showMenu })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showBack)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "asHeaderMobile_col -back",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.avatar)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "asHeaderMobile_avatar",
              src: _ctx.avatar,
              alt: _ctx.title
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.title), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.nav)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
              class: "asHeaderMobile_menu"
            }, _hoisted_11))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showMenu)
      ? (_openBlock(), _createBlock(_component_as_menu, {
          key: 0,
          menu: _ctx.menu,
          class: "lSetting_asMenu -setting",
          "onClick:item": _ctx.selectMenuItem
        }, null, 8, ["menu", "onClick:item"]))
      : _createCommentVNode("", true)
  ], 2))
}